import ApiClient from "Store/client";

export const addBulkStudentAnswersToTestApi = (body: BulkTestAnswersPayload) =>
  ApiClient(`api/commands/add-bulk-student-answers-to-test`, {
    method: "POST",
    body
  });

export const addStudentRealTestApi = (body: StudentRealTestRequest) =>
  ApiClient<StudentRealTestResponse>("api/commands/assign-test-real-to-student", {
    method: "POST",
    body
  });

export const assignTestToStudentApi = (body) =>
  ApiClient(`api/commands/assign-test-to-student`, {
    method: "POST",
    body
  });

export const fetchStudentTestScoreApi = (student_id, student_test_id) =>
  ApiClient<TestScores>(`api/students/${student_id}/student_tests/${student_test_id}/score`);

export const fetchStudentTestSectionProblemsApi = (student_id, student_test_id, section_id) =>
  ApiClient<ProblemSection>(
    `api/students/${student_id}/student_tests/${student_test_id}/sections/${section_id}/problems`
  );

export const fetchTestByTestIdApi = (student_id, test_id) =>
  ApiClient<Test>(`api/students/${student_id}/student_tests/${test_id}`);

export const fetchTestsByStudentIdApi = (student_id, parameters) =>
    ApiClient<Test[]>(`api/students/${student_id}/student_tests${parameters}`);

export const postStudentTestReportLinkApi = (parameters) =>
    ApiClient(`api/commands/generate-link${parameters}`, {
        method: "POST"
    });

export const getStudentTestReportLinkApi = (parameters) =>
    ApiClient(`api/student-tests/report${parameters}`);

export const postStudentTestScoreApi = (student_id, student_test_id) =>
  ApiClient(`api/students/${student_id}/student_tests/${student_test_id}/score`, {
    method: "POST"
  });

export const resetStudentTestsApi = (body) =>
  ApiClient(`api/commands/reset-student-test`, { method: "POST", body });

export const updateStudentRealTestApi = (body: Partial<StudentRealTestRequest>) =>
  ApiClient(`api/commands/update-student-real-test`, {
    method: "PATCH",
    body
  });

export const updateStudentTestAssignmentDateApi = (body) =>
  ApiClient(`api/commands/update-student-test-assignment-date`, {
    method: "PATCH",
    body
  });

export const updateStudentTestDueDateApi = (body) =>
    ApiClient(`api/commands/update-student-test-due-date`, {
        method: "PATCH",
        body
    });

export const updateStudentTestNotifyApi = (body) =>
    ApiClient(`api/commands/update-student-test-notify`, {
        method: "PATCH",
        body
    });
export const updateStudentTestPaceApi = (body) =>
    ApiClient(`api/commands/update-student-test-pace`, {
        method: "PATCH",
        body
    });

export const updateStudentTestLatenessApi = (body: UpdateTestLatenessRequest) =>
  ApiClient(`api/commands/excuse-student-test-lateness`, {
    method: "PATCH",
    body
  });

export const updateStudentTestSectionsApi = (body) =>
  ApiClient(`api/commands/update-student-test-sections`, {
    method: "PATCH",
    body
  });

export const updateStudentTestSectionStatusApi = (body) =>
  ApiClient(`api/commands/update-student-test-section-status`, {
    method: "PATCH",
    body
  });

export const updateStudentTestStatusApi = (body) =>
  ApiClient(`api/commands/update-student-test-status`, {
    method: "PATCH",
    body
  });

export const deleteStudentTestApi = (body) =>
  ApiClient(`api/commands/delete-student-test`, { method: "DELETE", body });

export const fetchStudentTestSectionsApi = (student_id, student_test_id) =>
  ApiClient(`api/students/${student_id}/student_tests/${student_test_id}/sections`);

export const updateStudentTestQuestionFlagStatusApi = (body) =>
  ApiClient(`api/commands/update-student-test-question-flag-status`, {
    method: "PATCH",
    body
  });

export const updateStudentEssayScoreApi = (body) =>
  ApiClient(`api/commands/update-student-test-essay-score`, {
    method: "PATCH",
    body
  });

export const addStudentTestQuestionFlagApi = (
  body: Omit<AddStudentTestFlagPayload, "test_section_id">
) =>
  ApiClient(`api/commands/add-student-test-question-flag`, {
    method: "POST",
    body
  });

export const fetchTestsByStudentIdScoredApi = (student_id: string, parameters: string) =>
  ApiClient<ScoredTest[]>(`api/students/${student_id}/student_tests?scored=1${parameters}`);

export const fetchStudentReportPDFApi = (studentId: string, testId: string, body) =>
  ApiClient<Blob>(`api/students/${studentId}/student_tests/${testId}/score/report`, {
    method: "POST",
    body,
    type: "blob"
  });

export const fetchTribyteTestSectionApi = (body: FetchTribyteTestSectionRequest) =>
  ApiClient("api/commands/review-tribyte-test-section", {
    method: "POST",
    body
  });
